<template>
  <div>
    <!-- Map Area Starts -->
    <section class="map-area section-padding hangye_section1 section" style="height: 960px;">
      <div class="banner-sun">
        <p class="p1 animate fadeInDown animated jjfangan_zt1"
          style="animation-duration: 0.5s; animation-delay: 0.1s; visibility: visible;">行业应用</p>
        <p class="p2 animate zoomIn animated jjfangan_zt2"
          style=" animation-duration: 0.8s; animation-delay: 0.5s; visibility: visible;  color: #E91E63;">INDUSTRY
          APPLICATIONS</p>
      </div>
    </section>
    <!-- Map Area End -->
    <!-- 合作伙伴 starts -->

    <section class="section-padding8 section" style="background: #eaeff2;">
      <div class="jiashangyigegao" style="width: 100%; display: flex;">
        <div style="width: 80%;margin-left: 12%;">

          <div class="wow fadeInDown40 animated geiniyig"
            style="animation-duration: 1s; animation-delay: 0.3s; width: 100%; text-align: center; padding: 50px 0px;">
            <p>
            <h3 class="yingyongziti">请尝试在所属行业中搜索您要查找的产品</h3>
            </p>
            <p class="yingyongziti2"> Please try searching for the product you are looking for in your industry</p>
            <!-- <p class="yingyongfenlei">右滑查看更多分类-></p> -->
          </div>
          <p class="yingyongfenlei" style="text-align: center;">右滑查看更多分类-></p>
          <div class="search_sun  wow fadeInLeft animated" style="animation-duration: 0.7s; animation-delay: 0.2s;">
            <ul>

              <li v-for="(item, index) in hangyelist" :key="index" v-if="item == xuanzhong" @click="hangyexz(item)"
                style="background: #4ec2bf;color: #ffffff;">

                <i :class="'biaoqian biaoqian' + index"></i>
                <p>
                  {{ item }}
                </p>
              </li>
              <li v-else @click="hangyexz(item)">
                <i :class="'biaoqian biaoqian' + index"></i>
                <p>
                  {{ item }}
                </p>
              </li>

            </ul>
          </div>

          <div class="wow fadeInDown40 animated anleibiece geiniyig"
            style="animation-duration: 0.5s; animation-delay: 0.3s;width: 100%; text-align: center; padding: 50px 0px; margin-top: 50px;">
            <p>
            <h3 class="yingyongziti">按类别筛选</h3>
            </p>
            <p class="yingyongziti2">Choose category</p>
            <!-- <p class="yingyongfenlei">右滑查看更多分类-></p> -->
          </div>
          <p class="yingyongfenlei" style="text-align: center;">右滑查看更多分类-></p>

          <div class="search_sun2  wow fadeInLeft animated " style="animation-duration: 0.7s; animation-delay: 0.3s;">
            <div>
              <ul>
                <li v-if="fenleixz == 7" style="background: #4ec2bf;color: #ffffff;" @click="fenlei(7)">
                  <p>全部</p>
                  <p>All</p>
                </li>
                <li v-else @click="fenlei(7)">
                  <p>全部</p>
                  <p>All</p>
                </li>

                <li v-for="(item, index) in cplist" :key="index" @click="fenlei(item.scode)" v-if="item.scode == fenleixz"
                  style="background: #4ec2bf;color: #ffffff;">
                  <p>{{ item.name }}</p>
                  <p style="font-size:12px">{{ item.subname }}</p>
                </li>
                <li v-else @click="fenlei(item.scode)">
                  <p>{{ item.name }}</p>
                  <p style="font-size:12px">{{ item.subname }}</p>
                </li>
              </ul>
            </div>
          </div>






        </div>

      </div>

    </section>
    <div class="chanpin_s1_hy">
      <!---明天检测一下  prductlist 和 cpinfo  里面显示的内容为什么显示标签-->
      <div v-for="(item, index) in prductlist" :key="index" class="chanpin_s2_01  wow zoomIn animated"
        style="animation-duration: 1s; animation-delay: 0.3s;">
        <a :href="'/chanpin?id=' + item.id" target="_blank">
          <div class="chanpin_s101_a_hy">
            <div class="chanpin_s101_a22">
              <img :src="newurl + item.ico" />
            </div>
            <div class="chanpin_s101_a23" style="height:180px; overflow: hidden;">

              <p style="font-size: 18px;color:#4ec2bf;">{{ item.ext_c2 }}</p>
              <p style="color: #718096;" v-html="truncatecontent(item.ext_xingneng)">

              </p>
            </div>
            <p style="font-size: 16px;color: #666666; width:100%; text-align:center;line-height:60px;">{{ item.title }}
            </p>
          </div>
        </a>
      </div>


      <div class="hy_fenye">
        <span @click="fanye(1)">首页</span>
        <!-- <span><<</span> -->

        <span v-for="n in countsum" :key="n" v-if="n == issum" @click="fanye(n)" class="hy_xz">
          {{ n }}
        </span>
        <span v-else @click="fanye(n)">
          {{ n }}
        </span>
        <span>{{ issum }}/{{ countsum }}</span>
        <!-- <span>>></span> -->
        <span @click="fanye(countsum)">尾页</span>
      </div>


    </div>





    <!-- 合作伙伴 end -->

  </div>
</template>

<style>
.chanpin_s101_a23 span {
  text-wrap: balance !important;
}

.biaoqian {
  display: inline-block;
  font: normal normal normal 14px / 1 FontAwesome;
  font-size: 50px;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

.biaoqian0:before {
  content: "\f238";
}

.biaoqian1:before {
  content: "\f135";
}

.biaoqian2:before {
  content: "\f1e9";
}

.biaoqian3:before {
  content: "\f1ee";
}

.biaoqian4:before {
  content: "\f1b8";
}

.biaoqian5:before {
  content: "\f21a";
}

.biaoqian6:before {
  content: "\f161";
}

.biaoqian7:before {
  content: "\f171";
}

.biaoqian8:before {
  content: "\f1d0";
}

.biaoqian9:before {
  content: "\f1b9";
}

.biaoqian10:before {
  content: "\f0c3";
}

.biaoqian11:before {
  content: "\f1b3";
}

.biaoqian12:before {
  content: "\f0f9";
}

/* .biaoqian13:before {
    content: "\f135";
	}
	.biaoqian14:before {
    content: "\f135";
	}
	.biaoqian15:before {
    content: "\f135";
	}
	.biaoqian16:before {
    content: "\f135";
	}
	.biaoqian17:before {
    content: "\f135";
	}
	.biaoqian18:before {
    content: "\f135";
	}
	.biaoqian19:before {
    content: "\f135";
	}
	.biaoqian20:before {
    content: "\f135";
	} */
</style>


<script>
import axios from 'axios';
export default {
  data() {
    return {
      xuanzhong: '',
      cplist: [],
      hangyelist: [],
      fenleixz: 7,
      cpinfo: [],
      key: '',
      issum: 1,
      countsum: 1,
      prductlist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {

    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/yingyonglist/name/ext_c4', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.hangyelist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/7/page/1', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.cpinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //获取产品分类
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/nav/scode/7', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.cplist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    this.key = this.$route.query.key
    if (this.key === undefined || this.key === null || this.key.trim() === '') {
      this.key = '';
    }
    this.huoqulist(this.fenleixz, this.xuanzhong, this.key)


  },
  methods: {
    fenlei(e) {
      // console.log(e)
      this.fenleixz = e
      this.huoqulist(e, this.xuanzhong)
    },
    hangyexz(e) {
      // console.log(e)
      this.xuanzhong = e
      this.huoqulist(this.fenleixz, e)
    },
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 400) {
      return dateStr.substring(0, length);
    },
    fanye(e) {
      console.log(e);
      this.issum = e;
      this.huoqulist(this.fenleixz, this.xuanzhong)
    },
    huoqulist(fenleixz, xuanzhong, key) {
      //按产品分类获取图片
      axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/yylist/scode/' + fenleixz + '/sum/' + this.issum + '?title=' + xuanzhong + '&key=' + key, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      })
        .then(response => {
          console.log(response.data.data);
          this.prductlist = response.data.data;
          this.countsum = response.data.tourl;

        })
        .catch(error => {
          console.error('当前网络环境异常!', error);
        });
    }


  }
};
</script>





// WEBPACK FOOTER //
// Yingyong.vue?60d46ef0